import { render, staticRenderFns } from "./brokerInsuredManagementDetails.vue?vue&type=template&id=563d9e5c&scoped=true"
import script from "./brokerInsuredManagementDetails.vue?vue&type=script&lang=js"
export * from "./brokerInsuredManagementDetails.vue?vue&type=script&lang=js"
import style0 from "./brokerInsuredManagementDetails.vue?vue&type=style&index=0&id=563d9e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563d9e5c",
  null
  
)

export default component.exports